// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "raw": "d814fdc",
    "hash": "d814fdc",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "d814fdc",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
